import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'

interface Props {
  role: RoleResponse
}

const AdminManifestationCard = ({ role }: Props) => {
  const i18n = useI18n()

  return (
    <MainContainer>
      <TopContainer>
        <Name numberOfLines={2} ellipsizeMode="tail">
          {role.name}
        </Name>
      </TopContainer>

      <BottomContainer>
        <Info numberOfLines={1} ellipsizeMode="tail">
          {i18n.t('screens.admin.roles.scopes', { count: role.scopes.length })}
        </Info>
      </BottomContainer>
    </MainContainer>
  )
}

export default AdminManifestationCard

const MainContainer = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `width: 360px;`}
  ${(props) => props.theme.constants.shadow};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.incident};
  overflow: hidden;
`

const TopContainer = styled(View)`
  padding: 16px 24px;
  height: 76px;
  background-color: ${(props) => props.theme.colors.background};
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Option};
`

const BottomContainer = styled(View)`
  padding: 16px 24px;
`
